// extracted by mini-css-extract-plugin
export var active = "_6y-a";
export var activeIndicator = "_6y-9";
export var disabled = "_6y-b";
export var fullWidth = "_6y-2";
export var lg = "_6y-7";
export var md = "_6y-6";
export var redoButtonTabGroup = "_6y-0";
export var sm = "_6y-5";
export var tabButton = "_6y-4";
export var tabButtonsContainer = "_6y-1";
export var themeDestructive = "_6y-d";
export var themeNormal = "_6y-c";
export var themeSuccess = "_6y-e";
export var xl = "_6y-8";
export var xs = "_6y-3";